import React, {ReactNode} from 'react';

import * as styles from 'src/components/organisms/BlogPage/BlogContent/BlogContent.module.scss';
import './BlogContent.scss';
import 'src/components/organisms/CodeSnippet/CodeSnippet.scss';

type Props = {
    header?: ReactNode
    content: ReactNode
}

export const BlogContent = ({header, content}: Props) => {
    return (
        <div className={styles.container}>
            <div className="blog-content">
                {header}
                {content}
            </div>
        </div>
    )
}
